import { useState } from 'react';

import Button from 'components/field/Button';
import Menu from 'components/global/Menu';
import Tooltip from 'components/global/Tooltip';
import Typography from 'components/global/Typography';

import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faCopy, faEnvelope, faPhone } from '@fortawesome/pro-regular-svg-icons';

const PhoneViewer = ({ value }) => {
	const [shareMenuButtonRef, setShareMenuButtonRef] = useState(null);

	const phoneMenuItems = [
		{
			label: 'phoneCall',
			url: 'tel:',
			icon: faPhone
		},

		{
			label: 'WhatsApp',
			url: 'https://wa.me/',
			icon: faWhatsapp
		},
		{
			label: 'sendSMS',
			url: 'sms:',
			icon: faEnvelope
		},
		{
			label: 'copy',
			url: 'copy:',
			icon: faCopy
		}
	];

	return (
		<>
			<Tooltip title="phoneViewerButtonTooltip" placement="top">
				{value ? (
					<Button ref={setShareMenuButtonRef} variant="blueBorderless" fullWidth>
						<Typography color="var(--blue)" showCopyButton>
							{value}
						</Typography>
					</Button>
				) : (
					<></>
				)}
			</Tooltip>

			<Menu
				placement="right-start"
				buttonRef={shareMenuButtonRef}
				hoverMode={false}
				menuItems={phoneMenuItems.map((item) => ({
					label: item.label,
					icon: item.icon,
					action: () => {
						if (item.url === 'copy:') {
							navigator.clipboard.writeText(value);
							return;
						}
						window.open(item.url + value, '_self');
					}
				}))}
			/>
		</>
	);
};

export default PhoneViewer;
